<template>
  <div class="container-fluid">

    <div class="pt-5 row d-none d-lg-flex full-height">
      <div class="d-none d-lg-block col-md-3">
        <side-menu :showInfoTv="showInfoTv" :tv="currTv" :currentProgram="infoCurrentProgram" :futureProgram="futureProgram"/>
      </div>
      
      <div class="col-lg-9 col-md-12">
              
        <div class="row d-none d-lg-flex align-items-stretch justify-content-center w-100">
          <div class="col-md-5 text-left">
            <div class="row">
              <div class="col-3">
                <img src="../assets/images/icona_live_tv.png" class="img-fluid"  > 
              </div>
              <div class="col pt-4">
                <span class="text-white mt-2" id="text_logo">LIVE TV</span><br>
                <span id="text">Canali in Streaming</span>
              </div>
              <div class="d-md-none d-sm-flex col-2 pt-5">
                <a :href="this.backlink">
                  <figure class="figure">
                      <img src="../assets/images/go_back_icon.png" class="img-fluid"> 
                      <figcaption class="figure-caption text-white">BACK</figcaption>
                  </figure>
                </a>
              </div>
            </div>

          </div>
          <div class="d-md-flex col-md-7 align-items-center justify-content-end">
            <div class="w-100">
              <search :back="true" :backlink="this.backlink" :callbackSearch="callbackSearch"></search>  
            </div> 
          </div>  
          
        </div>

        <nav aria-label="breadcrumb">
          <ol class="breadcrumb defaut-color pt-5">
            <li class="breadcrumb-item"><router-link to="/"><strong>Home</strong></router-link></li>
            <li class="breadcrumb-item active text-white" aria-current="page"><strong>Regioni</strong></li>
          </ol>
        </nav>
        <br>
        <h2 class="text-white text-left">Lista Regioni </h2>
        <hr>
        <div class="row">
            <div class="col-md-3" v-for="(value , key) in this.tvRegioni" v-bind:key="key">
              <router-link :to="'/search-province/'+key ">
                <card-regione :regione="key" :count="value['count']"></card-regione> 
              </router-link>
            </div>
        </div>
        <footer class="navbar footer fixed-bottom-20 navbar-trasparent text-center px-5">
          <main-footer />
        </footer>
      </div>
    </div>
    <!-- MOD. RESPONSIVE -->
    <div class="row pt-4 d-lg-none d-md-flex" style="height:700px;">
      <div class="col-12">
      <div class="row d-flex align-items-stretch justify-content-center">
          <div class="col-md-12 align-items-center justify-content-end pb-3">
            <search :back="true" :backlink="this.backlink"></search>   
          </div>
          <div class="col-md-12 text-left">
            <div class="row align-items-center">
              <div class="pl-3">
                <img src="../assets/images/icona_live_tv_sm.png" class="img-fluid"  > 
              </div>
              <div class="col pt-2">
                <span class="text-white" id="text_logo">LIVE TV</span><br>
                <span id="text">Canali in Streaming</span>
              </div>
            </div>
          </div>
        </div>

        
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb defaut-color pt-5">
            <li class="breadcrumb-item"><router-link to="/"><strong>Home</strong></router-link></li>
            <li class="breadcrumb-item active text-white" aria-current="page"><strong>Regioni</strong></li>
          </ol>
        </nav>
        <br>
        <h2 class="text-white text-left">Lista Regioni </h2>
        <hr>
        <div class="row">
            <div class="col-md-3" v-for="(value , key) in this.tvRegioni" v-bind:key="key">
              <router-link :to="'/search-province/'+key ">
                <card-regione :regione="key" :count="value.count"></card-regione> 
              </router-link>
            </div>
        </div>
        </div>
        <footer class="navbar footer navbar-trasparent text-center pt-5 px-5">
          <main-footer />
      </footer>
    </div>         
  </div>  
</template>

<script>
// @ is an alias to /src
//import MainHeader from '@/components/MainHeader.vue'
import Tv from '../api/tv.js';
import SideMenu from '@/components/SideMenu.vue'
import Search from '@/components/Search.vue'
import CardRegione from '@/components/CardRegione.vue'
import MainFooter from '@/components/MainFooter.vue'
import { mapState } from 'vuex'
//import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'SearchTerritorio',
  data: function() {
    return  {
      backlink: "javascript:history.go(-1)",
      regioni: [],
      showInfoTv: null,
      currTv: null,
      infoCurrentProgram: null,
      futureProgram: null,
      //tvRegioni: "",
    };
  },
  components: {
    SideMenu,CardRegione,Search,MainFooter
  },
  computed: {    
    ...mapState({
        user: state => state.User
    }),
    tvRegioni: function ()  {
      return this.user.tvTerritorio;
    }
  },
  methods: { 
      callbackSearch(searchKey) {
        //console.log("callbackSearch",searchKey);
        this.tv = [];
        let apiTv = new Tv();
        apiTv.getSearchTv(searchKey)
          .then(response => {
            //console.log(response.data)
            if(response.data) {
              this.tv = response.data;
            } else {
              //console.log("Nessun dato ricevuto");
            }
          })
          .catch(function (error) {
                console.log(error);                       
          }); 
      }
  },
  mounted:function(){
    //console.log("mounted SearchList");
  },
  created: function() {
      //console.log("created SearchList");
      this.backlink = window.history.state == null ? "/" : this.backlink;
      this.searchKey = this.$route.params.search_key;  
  }
}
</script>

<style scoped lang="scss">

#text_logo{
    font-weight:bold;
    font-size:36px;
}

#text{
  font-size:20px;
  font-weight:normal;
  color: #ddd;
}

.full-height{
  height:800px;
}

@media(max-width:767px){
  .full-height{
    height:100%;
  }
}
</style>